<template>
  <div
    class="OfferBox bg-primary rounded-xl p-8 grid grid-cols-1 md:grid-cols-2 gap-8"
  >
    <div class="flex flex-col gap-4 text-white">
      <div class="font-bold text-4xl">
        {{ $t("offerBox.title") }}
      </div>
      <p class="text-2xl">
        <i18n path="offerBox.message" />
      </p>
      <p class="text-xl">
        {{ $t("offerBox.step1") }}
      </p>
      <p class="text-xl">
        {{ $t("offerBox.step2") }}
      </p>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }" class="flex flex-col gap-4">
      <p class="text-2xl font-bold text-white">
        {{ $t("offerBox.enterTask") }}
      </p>
      <JoszakiTextAreaOld
        v-model="tenderText"
        :placeholder="placeholder"
        @focus="$trackers.trackClick('OfferBoxInput')"
      />
      <JoszakiButton inverted @click="handleSubmit(requestTender)">
        {{ $t("offerBox.subscribeButton") }}
      </JoszakiButton>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tenderText: "",
    };
  },
  methods: {
    requestTender() {
      this.$trackers.trackClick("OfferBoxButton");

      this.$emit("requestTender", this.tenderText);
    },
  },
};
</script>

<style lang="scss"></style>
